<template>
    <page>
        <module enable-flex>
            <module-tab title="兑换商品" @mounted="loadTabPage(1)" @activated="loadTabPage(1)" @click="loadTabPage(1)">
                <module-column enable-flex>
                    <m-search ref="search" @search="searchHandle">
                        <c-form>
                            <c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
                            <c-form-item type="input" label="规格规格" name="product_sku_spec" placeholder="模糊匹配"></c-form-item>
                            <c-form-item v-if="systemConfig.product_number_required == 'ON'" type="input" label="货号" name="product_itemnumber" placeholder="精确匹配"></c-form-item>
                            <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
                            <c-form-item v-if="systemConfig.share_enable == 'ON'" type="select" label="销售模式" name="sales_model"
                                       :options="searchSalesModelOptions"></c-form-item>
                            <c-form-item v-if="systemConfig.share_enable == 'ON'" type="checkbox" label="可售范围"
                                       name="visible_user_level" :options="userLevelOptions"></c-form-item>
                        </c-form>
                    </m-search>

                    <m-operate>
                        <c-button power="b_points_product_edit" color="sys" @click="addProduct">添加商品</c-button>
                        <c-button power="b_points_product_edit" color="sys" hollow @click="deleteProduct(null,1)">批量删除商品</c-button>
                    </m-operate>

                    <c-table ref="table">
                        <c-table-column type="selector"></c-table-column>

                        <c-table-column
                                label="商品信息"
                                width="350"
                        >
                            <template v-slot="{data}">
                                <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                                <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="销售模式"
                            width="75"
                            name="sales_model"
                            v-if="systemConfig.share_enable == 'ON'"
                        >
                          <template #default="{data}">
                            <span v-if="data.sales_model == 1" style="color:blue">供货</span>
                            <span v-else-if="data.sales_model == 2" style="color:darkgreen">直销</span>
                            <span v-else>--</span>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="可售范围"
                            width="80"
                            name="visible_user_level_name"
                            v-if="systemConfig.share_enable == 'ON'"
                        >
                          <template #default="{data}">
                            <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部用户'" style="color:blue">全部用户</span>
                            <span v-else v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                          </template>
                        </c-table-column>

                        <c-table-column
                                label="规格规格"
                                width="200"
                                name="product_sku_spec"
                        ></c-table-column>

                        <c-table-column
                                label="SKU编码"
                                width="100"
                                name="product_sku_code"
                        ></c-table-column>

                        <c-table-column
                                label="所需积分"
                                name="points"
                                width="80"
                        ></c-table-column>

                        <c-table-column
                                label="兑换单价"
                                name="exchange_price"
                                width="80"
                        >
                            <template v-slot="{data}">￥{{data.exchange_price}}</template>
                        </c-table-column>

                        <c-table-column
                                label="原售价"
                                name="product_price"
                                width="80"
                        >
                            <template v-slot="{data}">￥{{data.product_price}}</template>
                        </c-table-column>

                        <c-table-column
                                label="商品库存"
                                name="stock_count"
                                width="80"
                        ></c-table-column>

                        <c-table-column
                                type="button"
                                fixed="right"
                                label="操作"
                                width="140"
                        >
                            <template v-slot="row">
                                <c-table-button power="b_points_product_edit" @click="setPoints(row)">设置积分</c-table-button>
                                <c-table-button power="b_points_product_remove" @click="deleteProduct(row,1)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-column>
            </module-tab>

            <module-tab title="兑换优惠券" @mounted="loadTabPage(2)" @activated="loadTabPage(2)">
                <module-column enable-flex>
                    <m-search ref="search" @search="searchHandle">
                        <c-form>
                            <c-form-item type="input" label="优惠券名称" name="coupon_name"></c-form-item>
                        </c-form>
                    </m-search>

                    <m-operate>
                        <c-button power="b_points_product_edit" color="sys" @click="addCoupon">添加优惠券</c-button>
                        <c-button power="b_points_product_edit" color="sys" hollow @click="deleteProduct(null,2)">批量删除优惠券</c-button>
                    </m-operate>

                    <c-table ref="couponTable">
                        <c-table-column type="selector"></c-table-column>

                        <c-table-column
                                label="优惠券名称"
                                name="coupon_name"
                                width="150"
                        >
                        </c-table-column>

                        <c-table-column
                                label="优惠力度"
                                name="detail"
                                width="120"
                        ></c-table-column>

                        <c-table-column
                                label="适用范围"
                                name="commodity_range"
                                width="70"
                        >
                            <template v-slot="{data}">
                                {{dict.couponRange[data.commodity_range]}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="剩余可领"
                                name="surplus"
                                width="70"
                        ></c-table-column>

                        <c-table-column
                                label="所需积分"
                                name="points"
                                width="80"
                        ></c-table-column>

                        <c-table-column
                                type="button"
                                fixed="right"
                                label="操作"
                                width="140"
                        >
                            <template v-slot="row">
                                <c-table-button power="b_points_product_edit" @click="setPoints(row)">设置积分</c-table-button>
                                <c-table-button power="b_points_product_edit" @click="deleteProduct(row,2)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-column>
            </module-tab>

        </module>

        <c-dialog ref="pointsDialog" title="设置兑换所需积分" width="450" height="250" @resolve="setPointsHandle">
            <c-form ref="pointsForm">
                <c-form-item type="number" label="所需积分" name="points" :limit="[1, 99999]" required></c-form-item>
                <c-form-item type="number" label="兑换单价" name="exchange_price" decimal="2" :limit="[0, 99999]" word="不填写售价则默认0，添加则表示该商品兑换需要消耗X积分后，再支付Y元"></c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="addDialog" title="添加可兑换商品" width="900" @resolve="addProductHandle">
            <m-operate>
                <c-button color="sys" @click="$refs.productSelector.open()">添加商品</c-button>
            </m-operate>

            <c-table ref="addTable" v-model="addList" height="400" :paging="false">
                <c-table-column
                        label="商品信息"
                        width="200"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="规格名称"
                        width="160"
                        name="product_sku_spec"
                ></c-table-column>

                <c-table-column
                    label="售价"
                    name="product_price"
                    width="80"
                >
                    <template v-slot="{data}">￥{{data.product_price}}</template>
                </c-table-column>

                <c-table-column
                        label="商品库存"
                        name="stock_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="所需积分"
                >
                    <template v-slot="row">
                        <c-input v-model="row.data.points" type="number"  decimal="0"  :limit="[1, 99999]"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        label="兑换单价"
                >
                    <template v-slot="row">
                        <c-input v-model="row.data.exchange_price" type="number" decimal="2" :limit="[0, 99999]"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="80"
                >
                    <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <c-dialog ref="addCouponDialog" title="添加可兑换优惠券" width="900" @resolve="addCouponHandle">
            <m-operate>
                <c-button color="sys" @click="$refs.couponSelector.open()">添加优惠券</c-button>
            </m-operate>

            <c-table v-model="couponList" height="400" :paging="false">
                <c-table-column
                        label="优惠券名称"
                        name="coupon_name"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="优惠力度"
                        name="detail"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="适用范围"
                        name="commodity_range"
                        width="70"
                >
                    <template v-slot="{data}">
                        {{dict.couponRange[data.commodity_range]}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="剩余可领"
                        name="surplus"
                        width="70"
                ></c-table-column>

                <c-table-column
                        label="所需积分"
                >
                    <template v-slot="row">
                        <c-input v-model="row.data.points" type="number"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="80"
                >
                    <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>

        <product-selector ref="productSelector" sku multiple @resolve="productSelectHandle"></product-selector>
        <coupon-selector ref="couponSelector" multiple @resolve="couponSelectHandle"></coupon-selector>
    </page>
</template>

<script>
import productInfo from '@/components/public/product_info.vue'
import productSelector from '@/components/service/product_selector.vue'
import couponSelector from '@/components/service/coupon_selector.vue'
import {mapState} from "vuex";

export default {
    name: 'm_points_product',

    components: {
        productInfo, productSelector, couponSelector
    },

    computed: {
        ...mapState(['systemConfig','userInfo','dict'])
    },

    data() {
        return {
            exchangeType:'',
            addList: [],
            couponList:[],
            searchSalesModelOptions: [
              {name: '供货',value: 1},
              {name: '直销',value: 2}
            ],
            userLevelOptions: []
        }
    },

    mounted() {
        this.$refs.search.search();
        this.initUserLevelOptions();
    },

    methods: {
        loadTabPage(exchangeType){
            this.exchangeType = exchangeType;
            this.$refs.search.search();
        },

        searchHandle(data) {
            data.exchange_type = this.exchangeType;// 1:兑换商品 2:兑换优惠券
            if(this.exchangeType == 1){
                this.$refs.table.load({
                    url: '/points_product/list',
                    data
                });
            }else{
                this.$refs.couponTable.load({
                    url: '/points_product/list',
                    data
                });
            }
        },
        //加载用户等级列表
        initUserLevelOptions() {
          this.request({
            url: '/user_level/options',
            data: {},
            success: data => {
              this.userLevelOptions = Array.from(data, item => {
                return {
                  name: item.name,
                  value: item.value
                }
              });
            }
          });
        },

        setPoints(item) {
            this._edit = item;
            this.$refs.pointsForm.set(item.data);
            this.$refs.pointsDialog.open();
        },

        setPointsHandle(stop) {
            stop();
            this.$refs.pointsForm.submit({
                url: '/points_product/edit',

                rule: {
                    points: '请填写所需积分'
                },

                dataFormatter: data => {
                    data.id = this._edit.data.id;
                    data.product_price = data.product_price||0;
                    return data;
                },

                success: data => {
                    this._edit.update({
                        points: data.points,
                        product_price: data.product_price||0
                    });
                    this.$refs.pointsDialog.close();
                    //刷新列表
                    this.$refs.table.update();
                    this.$message({
                        text: '设置成功'
                    });
                }
            })
        },

        deleteProduct(item,exchangeType) {
            if (item){
                this.$confirm({
                    text: exchangeType == 1 ? '确定要删除此商品吗？' :'确定要删除此优惠券吗？',
                    resolve: () => {
                        this.request({
                            url: '/points_product/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                if(exchangeType == 1){
                                    this.$refs.table.update();
                                }else{
                                    this.$refs.couponTable.update();
                                }
                            }
                        });
                    }
                });
            }else {
                var ids = [];
                var selectDatas = [];
                if(exchangeType == 1){
                    selectDatas = this.$refs.table.getRow('selected');
                }else{
                    selectDatas = this.$refs.couponTable.getRow('selected');
                }
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                if (!ids || !ids.length || ids.length == 0){
                    this.$message({
                        text: '请选择需要删除的记录',
                        icon: 'fail'
                    });
                }
                this.$confirm({
                    text: exchangeType == 1 ? '确定要删除选中的【'+ids.length+'】条商品记录吗？' :'确定要删除选中的【'+ids.length+'】条惠券记录吗？',
                    resolve: () => {
                        this.request({
                            url: '/points_product/delete',
                            data: {
                                ids: ids
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                if(exchangeType == 1){
                                    this.$refs.table.update();
                                }else{
                                    this.$refs.couponTable.update();
                                }
                            }
                        });
                    }
                });
            }
        },

        addProduct() {
            this.addList = [];
            this.$refs.productSelector.open();
        },

        productSelectHandle(list) {
            list = list.filter(item => {
                return !this.addList.find(row => {
                    return row.product_sku == item.product_sku;
                });
            });
            this.addList = this.addList.concat(list);
            this.$refs.addDialog.open();
        },

        addProductHandle(stop) {
            stop();

            if (!this.addList.length) {
                this.$message({
                    text: '请选择可兑换商品'
                });
                return;
            }

            if (this.addList.find(row => !row.points)) {
                this.$message({
                    text: '请填写商品所需积分'
                });
                return;
            }

            this.request({
                url: '/points_product/add',
                data: {
                    exchange_type:1,
                    list: Array.from(this.addList, (item) => {
                        return {
                            product_id: item.product_id,
                            product_sku: item.product_sku,
                            points: item.points,
                            exchange_price: item.exchange_price||0
                        }
                    })
                },
                loading: true,
                success: () => {
                    this.$refs.addDialog.close();
                    this.$refs.table.update(1);
                }
            })
        },

        addCoupon() {
            this.couponList = [];
            this.$refs.couponSelector.open();
        },

        couponSelectHandle(list) {
            list = list.filter(item => {
                return !this.couponList.find(row => {
                    return row.id == item.id;
                });
            });
            this.couponList = this.couponList.concat(list);
            this.$refs.addCouponDialog.open();
        },

        addCouponHandle(stop) {
            stop();

            if (!this.couponList.length) {
                this.$message({
                    text: '请选择可兑换优惠券'
                });
                return;
            }

            if (this.couponList.find(row => !row.points)) {
                this.$message({
                    text: '请填写优惠券兑换所需积分'
                });
                return;
            }

            this.request({
                url: '/points_product/add',
                data: {
                    exchange_type:2,
                    list: Array.from(this.couponList, (item) => {
                        return {
                            coupon_id: item.id,
                            points: item.points
                        }
                    })
                },
                loading: true,
                success: () => {
                    this.$refs.addCouponDialog.close();
                    this.$refs.couponTable.update(1);
                }
            })
        },

    }
}
</script>